<div class="app-primary-bg"
    [ngStyle]="{'background-color':this.settingsData.form_bg_color && !router.url.includes('/signup')? this.settingsData.form_bg_color:'','font-family': settingsData.font_family ? settingsData.font_family : '' }">
    >
    <div class="container">
        <div class="row pt-110 pb-120 ml-65">
            <div class="col-md-6 pt-120 pb-100">
                <div class="pb-100 landing-page-auth">
                    <ng-container>
                        <a href="https://play.google.com/store/apps/details?id=com.gfl.network" target="_blank"><img
                                [src]="assets_url + 'website/homepage/googleplay.png'" width="130px" class="ml-10"  alt="Google Play"></a>
                        <a href="https://apps.apple.com/in/app/arevea/id1535047464" target="_blank"><img
                                [src]="assets_url + 'website/homepage/appstore.png'" width="130px" class="ml-10"  alt="App Store"></a>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>